import { Colors } from "@/enums/Colors";
import { Button, ListItemIcon, styled, Typography } from "@mui/material";
import { FieldValues } from "react-hook-form";
import NextLogo from "../../../assets/images/next-logo.png";

interface Props {
  text?: string;
  handleContinue?: (i: FieldValues) => void;
  center?: boolean;
  buttonColor?: string;
  hideIcon?: boolean;
  minWidth?: string;
  disabled?: boolean;
}

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "center" && prop !== "buttonColor",
})<Props>(({ theme, center, buttonColor, minWidth }) => ({
  backgroundColor: buttonColor ?? Colors.ELEGANT_BLACK,
  borderRadius: ".5rem",
  minWidth: minWidth ?? "10rem",
  minHeight: "3rem",
  textTransform: "none",
  ...(center && { margin: "auto" }),
  "&.Mui-disabled": {
    backgroundColor: "#d3d3d3",
  },
  "&:hover": {
    backgroundColor: buttonColor ?? Colors.ELEGANT_BLACK,
  },
  [theme.breakpoints.down("md")]: {
    margin: 0,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const TextButton = styled(Typography)(({ theme }) => ({
  color: Colors.WHITE,
  fontSize: ".875rem",
  fontWeight: "bold",
}));

export const ContinueButton = ({ text, center, buttonColor, hideIcon, handleContinue, minWidth, disabled = false }: Props) => {
  return (
    <StyledButton buttonColor={buttonColor} center={center} onClick={handleContinue} minWidth={minWidth} disabled={disabled}>
      <TextButton>{text ?? "Continue"}</TextButton>
      {!hideIcon && (
        <ListItemIcon>
          <img src={NextLogo.src} />
        </ListItemIcon>
      )}
    </StyledButton>
  );
};
